<template>
  <div class="context upload_img_view">
    <template v-if="viewData && Array.isArray(viewData) && viewData.length">
      <div v-if="!expand">
        <el-image
          v-for="(file, index) in viewData.slice(0, maxLength)"
          :style="`width: ${$attrs.width || 86}px; height: ${
            $attrs.height || 86
          }px`"
          :src="`${baseUrl}/jfzg/file/api/file/download?key=${file.id}&access_token=${token}`"
          :key="index"
          :preview-src-list="[
            `${baseUrl}/jfzg/file/api/file/download?key=${file.id}&access_token=${token}`,
          ]"
          :fit="fit"
        >
        </el-image>
      </div>
      <div v-else>
        <el-image
          v-for="(file, index) in viewData"
          :style="`width: ${$attrs.width || 86}px; height: ${
            $attrs.height || 86
          }px`"
          :src="`${baseUrl}/jfzg/file/api/file/download?key=${file.id}&access_token=${token}`"
          :key="index"
          :preview-src-list="[
            `${baseUrl}/jfzg/file/api/file/download?key=${file.id}&access_token=${token}`,
          ]"
          :fit="fit"
        >
        </el-image>
      </div>
      <i
        :class="{ 'el-icon-arrow-down': !expand, 'el-icon-arrow-up': expand }"
        @click="handleExpand"
        v-if="viewData.length > maxLength"
      ></i>
    </template>
    <template
      v-else-if="typeof viewData == 'string' && JSON.parse(viewData).id"
    >
      <el-image
        :style="`width: ${$attrs.width || 86}px; height: ${
          $attrs.height || 86
        }px`"
        :src="`${baseUrl}/jfzg/file/api/file/download?key=${
          JSON.parse(viewData).id
        }&access_token=${token}`"
        :preview-src-list="[
          `${baseUrl}/jfzg/file/api/file/download?key=${
            JSON.parse(viewData).id
          }&access_token=${token}`,
        ]"
        :fit="fit"
      >
      </el-image>
    </template>
    <template v-else-if="viewData && viewData.id">
      <el-image
        :style="`width: ${$attrs.width || 86}px; height: ${
          $attrs.height || 86
        }px`"
        :src="`${baseUrl}/jfzg/file/api/file/download?key=${viewData.id}&access_token=${token}`"
        :preview-src-list="[
          `${baseUrl}/jfzg/file/api/file/download?key=${viewData.id}&access_token=${token}`,
        ]"
        :fit="fit"
      >
      </el-image>
    </template>
    <span v-else> - </span>
  </div>
</template>

<script>
export default {
  inject: ["baseUrl"],
  props: {
    viewData: {
      type: [String, Array, Object],
      default: () => {
        return null;
      },
    },
    fit: {
      type: String,
      default: "contain",
    },
  },
  data() {
    return {
      maxLength: 0,
      expand: false,
    };
  },
  mounted() {
    this.init();
    console.log('我是图片查看');
  },
  computed: {
    token() {
      return sessionStorage.getItem("token");
    },
  },
  methods: {
    init() {
      this.maxLength = Math.floor(
        document.querySelector(".upload_img_view").offsetWidth /
          ((this.$attrs.width || 86) + 8)
      );
    },
    handleExpand() {
      this.expand = !this.expand;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload_img_view {
  .el-image {
    margin-right: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// packages/SrView/uploadImgView.vue